/**
 * Created by slava on 02.02.17.
 */

cleverapps.Scenes = function () {
    this.firstScene = true;
    this.onAvoidNodeVisibilityChanged = function () { };
};

cleverapps.refreshScene = function () {
    const sceneChange = function (f) {
        const scene = cleverapps.Scenes.GetRunningScene();
        scene.refreshFromTool = true;

        if (ComponentMap.get(scene, MainSceneComponent)) {
            cleverapps.meta.gotoMainLocation(f);
        } else if (typeof EditorScene !== "undefined" && scene instanceof EditorScene) {
            EditorScene.open({ level: Game.currentGame.level }, f);
        } else if (typeof AdminLocationsScene !== "undefined" && scene instanceof AdminLocationsScene) {
            AdminLocationsScene.open(f);
        } else if (typeof AdministratorScene !== "undefined" && scene instanceof AdministratorScene) {
            AdministratorScene.open(f);
        } else if (ComponentMap.get(scene, GameSceneComponent)) {
            if (cleverapps.config.editorMode) {
                f();
                LevelManager.getInstance().setLevel({
                    levelNo: cleverapps.environment.levelNo,
                    episodeNo: cleverapps.environment.episodeNo
                });
                LevelManager.getInstance().editLevel();
            } else if (["merge", "merge2"].includes(cleverapps.config.type)) {
                cleverapps.meta.gotoMainLocation(f);
            } else {
                Level.WantsToPlay(f, {
                    interstitial: false
                });
            }
        } else if (ComponentMap.getByName(scene, "HeroesSceneComponent")) {
            cleverapps.scenes.replaceScene(bundles.main.jsons.heroesscene_prefab_json, f);
        } else if (ComponentMap.getByName(scene, "DailyCupSceneComponent")) {
            cleverapps.scenes.replaceScene(bundles.main.jsons.dailycupscene_prefab_json, f);
        } else if (ComponentMap.getByName(scene, "BonusWorldSceneComponent")) {
            cleverapps.meta.gotoMainLocation(() => {
                cleverapps.scenes.replaceScene(Prefab.instantiate(bundles.main.jsons.bonusworldscene_prefab_json, { args: [cleverapps.missionManager.findRunningMission(Mission.TYPE_BONUS_WORLD)] }), f);
            });
        } else if (ComponentMap.getByName(scene, "OctopusHuntSceneComponent")) {
            cleverapps.scenes.replaceScene(Prefab.instantiate(bundles.main.jsons.octopushuntscene_prefab_json, { args: [cleverapps.missionManager.findRunningMission(Mission.TYPE_OCTOPUS_HUNT)] }), f);
        } else if (ComponentMap.getByName(scene, "WeeklyTournamentSceneComponent")) {
            cleverapps.scenes.replaceScene(bundles.main.jsons.weeklytournamentscene_prefab_json, f);
        }
    };

    if (cleverapps.focusManager.isFocused()) {
        cleverapps.focusManager.distract({
            focus: "sceneRefresh",
            action: sceneChange
        });
    } else {
        cleverapps.focusManager.display({
            focus: "sceneRefresh",
            action: sceneChange
        });
    }
};

cleverapps.Scenes.GetMovingNode = function (target) {
    for (; target; target = target.parent) {
        if (target.movingNode) {
            return target.movingNode;
        }
    }

    return cleverapps.Scenes.GetRunningScene().movingNode;
};

cleverapps.Scenes.GetRunningScene = function () {
    return cc.director.getRunningScene();
};

cleverapps.Scenes.GetSceneComponent = function (ComponentClass) {
    return ComponentMap.get(cleverapps.Scenes.GetRunningScene(), ComponentClass);
};

cleverapps.Scenes.CanTransitionFast = function (toScene) {
    const isLightweight = function (bundleName) {
        return !bundles[bundleName].meta.heavy;
    };
    return toScene.bundles.every((bundleName) => cleverapps.bundleLoader.isSingleLoaded(bundleName) || isLightweight(bundleName));
};

cleverapps.Scenes.prototype.replaceScene = function (toScene, f) {
    if (toScene instanceof VirtualJson) {
        toScene = Prefab.instantiate(toScene);
    }

    if (!cleverapps.focusManager.isFocused()) {
        cleverapps.focusManager.debugMessage(`Trying to replace scene without user focus! ${toScene.sceneName}`);
    }

    f = f || function () { };

    if (cleverapps.config.editorMode || cleverapps.config.demoMode) {
        cleverapps.silentIntro = true;
    }

    cleverapps.notification.clear();

    FingerView.remove(FingerView.currentFinger, true);
    PointerView.remove(PointerView.currentPointer);
    cleverapps.centerHint.remove();
    cleverapps.tooltipManager.clear();

    cleverapps.availableMove.clear();

    const location = cleverapps.meta.getSelectedLocation();
    if (location && location.clearAnimations) {
        location.clearAnimations();
    }

    let fromScene = cleverapps.Scenes.GetRunningScene();

    const canShowPreroll = (fromScene instanceof LoaderScene)
        && (connector.platform.oneOf(connector.GDCOM) || !cleverapps.user.isFirstSession())
        && cleverapps.config.type !== "merge";
    const usesPlatformLoadingScreenOnly = (fromScene instanceof LoaderScene)
        && !fromScene.loaderBackground;

    const start = Date.now();
    let transition = undefined;
    let transitionController = undefined;

    toScene.notLoaded = true;

    cleverapps.focusManager.compound(f, [
        (f) => {
            if (!usesPlatformLoadingScreenOnly) {
                this.startGameAndShowCanvas(f);
            } else {
                f();
            }
        },

        (f) => {
            cleverapps.dataVersion.displayUpgradeWindow(f);
        },

        (f) => {
            toScene.isAboutToShow = true;
            fromScene.isAboutToRemove = true;

            fromScene.sceneComponent.destructor();

            cleverapps.lazyAssets.unload();

            toScene.sceneComponent.prepareBundles(fromScene);

            f();
        },

        (f) => {
            transition = Transition.create(fromScene);
            transitionController = ComponentMap.getByName(transition, "TransitionController");
            fromScene.sceneComponent.transitionAnimationDidStart();
            f();
        },

        (f) => {
            f = cleverapps.wait(2, f);

            const canTransitionFast = usesPlatformLoadingScreenOnly || cleverapps.Scenes.CanTransitionFast(toScene);

            if (cleverapps.config.debugMode) {
                console.log("Loading during transition:", toScene.bundles.filter((bundleName) => !cleverapps.bundleLoader.isSingleLoaded(bundleName)));
            }

            let loaded = false;

            if (canTransitionFast) {
                toScene.sceneComponent.load(() => {
                    loaded = true;
                    f();
                });
            } else {
                f();
            }

            cleverapps.focusManager.compound(f, [
                (f) => {
                    setTimeout(f, 50);
                },

                (f) => {
                    if (cleverapps.config.debugMode) {
                        console.log("Fast transition state:", canTransitionFast, loaded);
                    }

                    if (loaded) {
                        f();
                    } else {
                        transitionController.show(f, cleverapps.silentIntro);
                    }
                },

                (f) => {
                    if (canTransitionFast && canShowPreroll && !usesPlatformLoadingScreenOnly) {
                        cleverapps.rewardedAdsManager.showPreroll(f);
                    } else {
                        f();
                    }
                },

                (f) => {
                    // runScene + setNextScene + unload must be called asynchronously to prevent switching an old scene
                    // in the middle of the director.drawScene call
                    setTimeout(f, 0);
                },

                (f) => {
                    if (cleverapps.bannerAd) {
                        cleverapps.bannerAd.check(true);
                    }

                    toScene.sceneComponent.onResizeWhileNotLoaded();

                    transition.replaceParent(toScene);

                    SceneComponent.RETAINED_NODES.forEach((node) => {
                        node.replaceParentSamePlace(toScene);
                    });

                    cc.director.runScene(toScene);
                    cc.director.setNextScene();

                    f();
                },

                (f) => {
                    fromScene.sceneComponent.unload(toScene);

                    let q = [fromScene];

                    while (q.length > 0) {
                        const t = q.pop();
                        q = q.concat(t.children);
                        t.removeAllChildren();
                    }

                    fromScene = undefined;
                    cleverapps.focusManager.resetWindows();

                    f();
                },

                (f) => {
                    f = cleverapps.wait(2, f);

                    if (canTransitionFast) {
                        f();
                    } else {
                        toScene.sceneComponent.load(f);
                    }

                    if (!canTransitionFast && canShowPreroll && !usesPlatformLoadingScreenOnly) {
                        cleverapps.rewardedAdsManager.showPreroll(f);
                    } else {
                        f();
                    }
                }
            ]);
        },

        (f) => {
            delete toScene.notLoaded;

            toScene.sceneComponent.handleSceneLoaded();

            cleverapps.resolution.resizeScene(false, true);

            f();
        },

        (f) => {
            if (cleverapps.config.debugMode && LoaderScene.start) {
                console.log("scene loading time", (Date.now() - LoaderScene.start) / 1000);
                LoaderScene.start = undefined;
            }

            if (cleverapps.toolModel && typeof ToolView !== "undefined" && !cleverapps.gameModes.noTools) {
                cleverapps.toolModel.reset();
                toScene.toolMenu = new ToolView();
                toScene.addChild(toScene.toolMenu);
                toScene.toolMenu.addOpener();
            }

            if (cc.game.isPaused()) {
                cc.game.step();
            }

            cleverapps.ConsoleStream.sendLoadingTime(`scene ${cleverapps.environment.scene} ${Date.now() - start}ms`);

            f();
        },

        (f) => {
            if (connector.platform.oneOf(connector.SP_MOBAGE)) {
                cleverapps.platformLogic.showLoginScreen(f);
            } else {
                f();
            }
        },

        (f) => {
            transitionController.hide(f);
        },

        (f) => {
            this.startGameAndShowCanvas(f);
        },

        (f) => {
            if (canShowPreroll && usesPlatformLoadingScreenOnly) {
                cleverapps.rewardedAdsManager.showPreroll(f);
            } else {
                f();
            }
        },

        (f) => {
            transition.removeFromParent();

            toScene.isAboutToShow = undefined;

            cleverapps.notification.processQueue();
            connector.platform.notifyGameReady();

            cleverapps.bundleLoader.preloadBundles(toScene.sceneComponent.options.preloadBundles || []);

            f();
        }
    ]);
};

cleverapps.Scenes.prototype.startGameAndShowCanvas = function (f) {
    if (this.firstScene) {
        this.firstScene = false;
        cleverapps.resolution.showCanvas();
        connector.platform.startGameCallback(f);
    } else {
        f();
    }
};

cleverapps.Scenes.SceneRefresh = function () {
    cleverapps.flags.reset();

    cleverapps.tutorial.stop();

    if (levels.tutorial) {
        levels.tutorial.stop();
    }

    if (connector.social.isLoggedIn()) {
        connector.social.getPlugin().onLogin();
    }

    connector.synchronizer.checkSession();

    if (cleverapps.isKnockoutGame()) {
        cleverapps.knockoutGame.stopRumble();
    }

    cleverapps.focusManager.distract({
        focus: "sceneRefresh",
        action: function (f) {
            cleverapps.meta.gotoMainLocation(f);
        }
    });
};